import { render, staticRenderFns } from "./ObservationsForm.vue?vue&type=template&id=1e916308&scoped=true"
import script from "./ObservationsForm.ts?vue&type=script&lang=ts&external"
export * from "./ObservationsForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e916308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e916308')) {
      api.createRecord('1e916308', component.options)
    } else {
      api.reload('1e916308', component.options)
    }
    module.hot.accept("./ObservationsForm.vue?vue&type=template&id=1e916308&scoped=true", function () {
      api.rerender('1e916308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/ObservationsForm/ObservationsForm.vue"
export default component.exports